import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import ClientSearch, { getTitle } from 'shared/ClientSearch'
import { translate } from 'loankeeper-common/helpers'
import { clientSearchModal, clientSearch, addRelationModal } from '../../../constants'
import { RelationGridRowData } from 'src/features/ClientDetails/types'

const clientSearchGridConfig = {
  syncGridState: true,
  enableRowSelection: true,
  enableColumnsHide: true,
  enableColumnsOrder: true,
  enableColumnsResize: true,
  enableSorting: true,
}

const onChoose = (
  closeClientSearchModal: () => void,
  openAddRelationModal: (data: RelationGridRowData) => void,
  row: RelationGridRowData,
) => {
  closeClientSearchModal()
  openAddRelationModal(row)
}

const getGetContextMenuItems =
  (closeClientSearchModal: () => void, openAddRelationModal: (data: RelationGridRowData) => void) =>
  ({
    node: {
      data,
      data: { Full_Name },
    },
  }: {
    node: { data: RelationGridRowData }
  }) =>
    [
      {
        name: Full_Name,
        disabled: true,
      },
      {
        name: translate('frm_client_list-cmd_select'),
        action: () => onChoose(closeClientSearchModal, openAddRelationModal, data),
        icon: 'hand',
      },
    ]

const getOnRowDoubleClicked =
  (closeClientSearchModal: () => void, openAddRelationModal: (data: RelationGridRowData) => void) =>
  ({ node: { data } }: { node: { data: RelationGridRowData } }) => {
    onChoose(closeClientSearchModal, openAddRelationModal, data)
  }

const ClientSearchModal: FC<{
  modalInstanceName: string
  closeModal: () => void
}> = ({ modalInstanceName, closeModal }) => {
  const dispatch = useDispatch()

  const title: string = useSelector((state) => getTitle(state, { instanceName: clientSearch }))

  const config = React.useMemo(() => {
    function handleOpenAddRelationModal(row: RelationGridRowData) {
      dispatch(LKModalActions.open({ name: addRelationModal, row }))
    }

    return {
      ...clientSearchGridConfig,
      onRowDoubleClicked: getOnRowDoubleClicked(closeModal, handleOpenAddRelationModal),
      getContextMenuItems: getGetContextMenuItems(closeModal, handleOpenAddRelationModal),
    }
  }, [dispatch, closeModal])

  return (
    <LKModal name={modalInstanceName} heading={title} size="lg">
      <ClientSearch instanceName={clientSearch} gridConfig={config} />
    </LKModal>
  )
}

export default LKModalContainer(clientSearchModal)(ClientSearchModal)
